(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["quantity-selector"] && !Shopify.designMode) return;
  try {
    class QuantityLastPieceAvailability extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      this.updateState(this.dataset.lastPiece === 'true');

      const target = this.closest('.shopify-section, dialog, product-card') || document;
      target.addEventListener('shopify:product:select', this.onProductSelect, {
        signal: this.abortController.signal,
      });
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    onProductSelect = async (event) => {
      const sourceCard = event.target instanceof Element ? event.target.closest('product-card') : null;
      if (sourceCard && !sourceCard.contains(this)) return;

      try {
        const { detail } = await event.promise;
        const newInput = detail?.html?.querySelector(
          'last-piece-availability input[ref="quantityInput"]'
        );
        if (!newInput) return;
        this.updateState(newInput.dataset.lastPiece === 'true');
      } catch {
        return;
      }
    };

    updateState(isLastPiece) {
      this.dataset.lastPiece = isLastPiece.toString();
      this.querySelector('quantity-selector-component')?.toggleAttribute('hidden', isLastPiece);
      this.querySelector('[data-last-piece-label]')?.toggleAttribute('hidden', !isLastPiece);
    }
  }

  if (!customElements.get('last-piece-availability')) {
    customElements.define('last-piece-availability', QuantityLastPieceAvailability);
  }
  } catch(e) { console.error(e); }
})();

})();
